import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  filtersGroup: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'flex-start',
    width: '100%',
    '&>.myev-MuiInput-root': {
      width: '48%',
    },
    '@media (min-width: 640px)': {
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      flexDirection: 'row',
      '&>.myev-MuiInput-root': {
        width: 'auto',
      },
    },
    '&>.Mui-error': {
      display: 'none',
    },
  },
  pageContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    flexWrap: 'wrap',
    gap: '8px',
    '@media (min-width: 640px)': {
      alignItems: 'flex-start',
      flexDirection: 'row',
    },
  },
}));
